type UseGetRiskFactorProps = {
    health: string | null;
    marginCallThreshold: string | null;
    liquidationThreshold: string | null;
};

const formatHealth = (riskFactor: number): string => {
    if (isNaN(riskFactor)) return 'N/A';

    const [integerPart, fractionalPart = ''] = riskFactor.toString().split('.');
    const paddedFractionalPart = fractionalPart.padEnd(2, '0').slice(0, 2);
    return `${integerPart}.${paddedFractionalPart}`;
};

const HIGH_RISK_THRESHOLD = 0.01;
const RISING_RISK = 0.02;

export const useGetRiskLevel = ({
    health,
    marginCallThreshold,
    liquidationThreshold,
}: UseGetRiskFactorProps) => {
    const loading = health === null;

    const riskFactor = parseFloat(health || '0');

    const pivotHighRisk = Number(marginCallThreshold);
    const pivotLowRisk = pivotHighRisk + RISING_RISK;
    const pivotHighRiskWithThreshold = pivotHighRisk + HIGH_RISK_THRESHOLD;

    const isLow = !loading && riskFactor > pivotLowRisk;
    const isWarning =
        !loading && riskFactor >= pivotHighRiskWithThreshold && riskFactor <= pivotLowRisk;
    const isHigh = !loading && riskFactor < pivotHighRiskWithThreshold;

    const isCloseToLiquidation = riskFactor < Number(marginCallThreshold);
    const isLiquidation = riskFactor < Number(liquidationThreshold);

    const formattedHealth = formatHealth(riskFactor);

    return {
        loading,
        isLow,
        isWarning,
        isHigh,
        formattedHealth,
        liquidationThreshold,
        marginCallThreshold,
        isLiquidation,
        isCloseToLiquidation,
        pivotLowRisk,
        pivotHighRiskWithThreshold,
    };
};
